import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  gap: 62px;
  span{
    margin-left: 4px;
    padding: 5px;
    border-radius: 10px;
    background-color: rgba(0, 255, 0, 0.2);
  }
  h1{
    color: white;
  }
  }
  > p {
    color: ${theme.colors.gray6};
    font-weight: bold;
    font-size: max(.8rem, 1.1vw);
  }
`;

export const TableDetail = styled.div`
border-radius: 8px;
max-height: 70vh;
margin-top: 5px;
display: block;
overflow: auto;
table {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  .agent th:first-child {
    width: 40%;
  }
  th:first-child {
    width: 35%;
  }
  th:last-child {
    width: 70;
  }
}
thead {
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px #e6e7edb3;
  opacity: 1;
  height: 44px;
}
th {
  text-align: left;
  border-left: 1px solid #F1F2F0;
  font-weight: 600;
  font-size: 16px;
  color: white;
  text-align: left;
  padding: 16px 10px;
  background-color: #7B33E2;
}
th span {
  display: flex;
  width: 100%;
}
.th_field {
  width: 90%;
}
.icon_field {
  display: none !important;
  width: 4%;
  cursor: pointer;
}
tr {
  height: 48px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px #E7E7EDB3;
}
td {
  text-align: left;
  border-left: 1px solid #F1F2F0;
  padding: 15px 25px;
}
td:last-child {
  border-left: none;
  span{
    padding: 5px;
    border-radius: 10px;
    background-color: rgba(0, 255, 0, 0.2);
  }
}
td:nth-last-child(2) {
  span{
    padding: 5px;
    border-radius: 10px;
    background-color: rgba(0, 255, 0, 0.2);
  }
}
::-webkit-scrollbar {
  height: 10px;
  width: 4px;
  border: 1px solid #d5d5d5;
  background-color: white;
  box-shadow: none !important;
  background-image: none !important;
}
.error-message {
  text-align: center;
  margin: 1% 0;
  color: red;
}
.all-display-none {
  display: none;
}`;

export const Main = styled.main`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-auto-rows: auto;
  overflow: hidden;
  padding: ${theme.spacings.xxlarge} ${theme.spacings.xxxlarge};
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    overflow: hidden;
  }

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;

    > .block {
      display: flex;

      &.column {
        flex-direction: column;
        gap: ${theme.spacings.medium};
      }

      p {
        font-size: ${theme.font.sizes.p2};
        line-height: ${theme.font.lineHeights.p2};
      }

      p.label {
        color: ${theme.colors.gray5};
        display: flex;
        align-items: center;
        column-gap: 0.2rem;
      }

      p.value {
        color: ${theme.colors.gray6};
        margin-left: ${theme.spacings.xxsmall};
      }
    }
  }
`;
